import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from '@mui/material/styles';
import { observer } from 'mobx-react';
import { FlexBox, Typography, useMediaQuery } from 'ml-rubiks-styleguide';
import { injectTSDI } from 'ml-webclient-common/src/tsdi';
import { I18nStore } from '../../core/i18n';
import { FastFinanceLinkStore } from '../../store';
const PAYMENT_METHOD_TRANSLATIONS = {
    DIRECT_DEBIT: 'ffl.payment.method.enum.sepa',
    CREDIT_CARD: 'ffl.payment.method.enum.credit.card',
    BANK_TRANSFER: 'ffl.payment.method.enum.bank.transfer',
    TWINT: 'ffl.payment.method.enum.twint',
    CASH: 'ffl.payment.method.enum.cash',
    INVOICE: 'ffl.payment.method.enum.invoice'
};
function InfoRow({ label, value, isMobile }) {
    if (isMobile) {
        return (_jsxs(FlexBox, { stack: true, sx: { mb: 1.5 }, children: [_jsxs(Typography, { variant: "body1", color: "text.secondary", children: [label, ":"] }), _jsx(Typography, { variant: "body1", fontWeight: 600, children: value })] }));
    }
    return (_jsxs(FlexBox, { gap: 1, sx: { mb: 0.5 }, children: [_jsxs(Typography, { variant: "body1", color: "text.secondary", children: [label, ":"] }), _jsx(Typography, { variant: "body1", fontWeight: 600, children: value })] }));
}
export const MemberInfo = observer(function MemberInfo() {
    const store = injectTSDI(FastFinanceLinkStore);
    const i18n = injectTSDI(I18nStore);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const { customerNumber, contracts, currentPaymentMethod } = store;
    if (!customerNumber && contracts.length === 0) {
        return null;
    }
    const paymentMethodName = currentPaymentMethod?.paymentMethod;
    function getPaymentMethodLabel(method) {
        const key = PAYMENT_METHOD_TRANSLATIONS[method];
        if (!key) {
            return method;
        }
        return i18n.__(key) || method;
    }
    return (_jsxs(FlexBox, { stack: true, children: [customerNumber && (_jsx(InfoRow, { label: i18n.__('ffl.update.payment.method.member.id'), value: customerNumber, isMobile: isMobile })), contracts.length > 0 && (_jsx(InfoRow, { label: i18n.__('ffl.update.payment.method.contracts'), value: contracts.join(', '), isMobile: isMobile })), paymentMethodName && (_jsx(InfoRow, { label: i18n.__('ffl.update.payment.method.current'), value: getPaymentMethodLabel(paymentMethodName), isMobile: isMobile }))] }));
});
